exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".negative-container[data-v-25d7fa8e]{background-color:#fff0eb;color:#ff5722;font-size:13px;line-height:18.82px;padding:12px 16px;display:-webkit-box;display:-ms-flexbox;display:flex;gap:0 12px}.negative-container img[data-v-25d7fa8e]{margin-top:2px;height:16px}.not-txt[data-v-25d7fa8e]{-webkit-box-flex:1;-ms-flex:1;flex:1;white-space:pre-line;padding-right:8px}", ""]);

// exports
